module.exports = __webpack_public_path__ + "static/img/function-blue.d04022a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/automation/function-blue.svg
// module id = 1qfQ
// module chunks = 46